<div (keydown.enter)="submit()" class="flex flex-col gap-5">

  <!-- Name -->
  <elcia-text-input [control]="form.controls.name" [label]="'licence-server.name' | translate"/>

  <!-- Row 2: assigned customer products -->
  <elcia-multi-dropdown
    [control]="form.controls.customerProductIds"
    [items]="customerProducts()"
    [label]="'licence-server.products'"
    [textField]="'productName'"
    [valueField]="'id'"/>

</div>
